import React, { useEffect, useState } from 'react';
import { Modal, Form, Button, Table } from 'react-bootstrap';
import API from '../services/api';
import ApprovalChip from './ApprovalChip';

const money = (n) => new Intl.NumberFormat('es-DO', { style: 'currency', currency: 'DOP' }).format(n || 0);

const ClientPricingModal = ({ client, onClose }) => {
  const [products, setProducts] = useState([]);
  const [overrides, setOverrides] = useState([]);
  const [productId, setProductId] = useState('');
  const [price, setPrice] = useState('');
  const [error, setError] = useState('');

  const loadOverrides = () => {
    API.get('/client-prices', { params: { client: client._id } })
      .then(res => setOverrides(res.data))
      .catch(err => console.error('Error loading client prices:', err));
  };

  useEffect(() => {
    API.get('/products').then(res => setProducts(res.data)).catch(err => console.error('Error loading products:', err));
    loadOverrides();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [client._id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!productId || price === '') {
      setError('Selecciona un producto y un precio.');
      return;
    }
    try {
      await API.post('/client-prices', { client: client._id, product: productId, price: Number(price) });
      setProductId('');
      setPrice('');
      loadOverrides();
    } catch (err) {
      setError(err.response?.data?.message || 'Error al guardar el precio especial.');
    }
  };

  const handleDelete = async (id) => {
    try {
      await API.delete(`/client-prices/${id}`);
      loadOverrides();
    } catch (err) {
      console.error('Error deleting client price:', err);
    }
  };

  return (
    <Modal show onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Precios especiales — {client.name}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && <div className="alert alert-danger">{error}</div>}

        <Form onSubmit={handleSubmit} className="d-flex gap-2 mb-3 align-items-end">
          <Form.Group className="flex-grow-1">
            <Form.Label>Producto</Form.Label>
            <Form.Select value={productId} onChange={e => setProductId(e.target.value)}>
              <option value="">Selecciona un producto...</option>
              {products.map(p => (
                <option key={p._id} value={p._id}>{p.name} ({money(p.price)})</option>
              ))}
            </Form.Select>
          </Form.Group>
          <Form.Group style={{ width: '140px' }}>
            <Form.Label>Precio especial</Form.Label>
            <Form.Control type="number" step="0.01" value={price} onChange={e => setPrice(e.target.value)} />
          </Form.Group>
          <Button type="submit">Guardar</Button>
        </Form>

        <Table size="sm" hover>
          <thead>
            <tr>
              <th>Producto</th>
              <th>Precio de lista</th>
              <th>Precio especial</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {overrides.map(o => (
              <tr key={o._id}>
                <td>{o.product?.name} <ApprovalChip entityId={o._id} className="ms-1" /></td>
                <td>{money(o.product?.price)}</td>
                <td style={{ color: 'var(--mm-cyan)', fontWeight: 600 }}>{money(o.price)}</td>
                <td className="text-end">
                  <Button size="sm" variant="outline-danger" onClick={() => handleDelete(o._id)}>Eliminar</Button>
                </td>
              </tr>
            ))}
            {overrides.length === 0 && (
              <tr><td colSpan={4} className="text-muted text-center">Este cliente paga el precio de lista en todo.</td></tr>
            )}
          </tbody>
        </Table>
      </Modal.Body>
    </Modal>
  );
};

export default ClientPricingModal;
